/** Exibição: `prefixo nome sobrenome` (omite partes vazias). */
export function formatProfessionalFullName(p: {
	name_prefix?: string | null;
	first_name?: string | null;
	last_name?: string | null;
}): string {
	return [p.name_prefix, p.first_name, p.last_name]
		.map((x) => (x == null ? '' : String(x).trim()))
		.filter((x) => x.length > 0)
		.join(' ');
}

/** Atalho compacto: com mais de 2 nomes, mantém só prefixo + 1º nome + 1º sobrenome. */
export function formatProfessionalShortcutName(p: {
	name_prefix?: string | null;
	first_name?: string | null;
	last_name?: string | null;
}): string {
	const firstNameParts = (p.first_name?.trim() ?? '')
		.split(/\s+/)
		.filter(Boolean);
	const lastNameParts = (p.last_name?.trim() ?? '')
		.split(/\s+/)
		.filter(Boolean);
	const nameParts = [...firstNameParts, ...lastNameParts];

	if (nameParts.length <= 2) {
		return formatProfessionalFullName(p);
	}

	const prefix = p.name_prefix?.trim() ?? '';
	const firstName = firstNameParts[0] ?? '';
	const lastName = lastNameParts[0] ?? '';

	return [prefix, firstName, lastName]
		.filter((part) => part.length > 0)
		.join(' ');
}
